import BaseAPI from "../base";
class NewsService extends BaseAPI {
  // 置顶新闻文章列表
  getTopArticleList(params) {
    return this.post({
      url: `${process.env.VUE_APP_NEWS_APIBASEURL}/YuanHe/News/TopArticleList`,
      data: params,
    });
  }
  // 新闻文章列表
  getArticleList(params) {
    return this.post({
      url: `${process.env.VUE_APP_NEWS_APIBASEURL}/YuanHe/News/ArticleList`,
      data: params,
    });
  }
  // 新闻文章详情
  getArticleDetail(params) {
    return this.post({
      url: `${process.env.VUE_APP_NEWS_APIBASEURL}/YuanHe/News/ArticleDetail`,
      data: params,
    });
  }
  //
  articleBrowseAddOne(params) {
    return this.post({
      url: `/YuanHe/News/ArticleBrowseAddOne`,
      data: params,
    });
  }
}

export default new NewsService();
